import type { GroupBase, GroupHeadingProps } from 'react-select';

import classNames from 'classnames';

/**
 * Renders a group heading for use within a react-select component.
 *
 * @template Option - The option type.
 * @template IsMulti - Indicates if multiple selections are allowed.
 * @template Group - The group type, extending GroupBase.
 * @param props - The props for the group heading component.
 * @param props.children - The content to display within the group heading.
 * @param props.selectProps.allowClickableHeader - Optional flag to apply a 'header' class for clickable headers.
 * @returns A div element containing the group heading content with appropriate class names.
 */
function GroupHeading<Option, IsMulti extends boolean, Group extends GroupBase<Option>>({
  children,
  selectProps: { allowClickableHeader = false },
}: GroupHeadingProps<Option, IsMulti, Group>) {
  return <div className={classNames('hsp-select-group-heading', { header: allowClickableHeader })}>{children}</div>;
}

export default GroupHeading;
